import { useContext, createContext } from 'react';

export const TeamActionContext = createContext(null);

export function useTeamActionContext() {
  return useContext(TeamActionContext);
}
